var map = {
	".": 8305,
	"./": 8305,
	"./App": 9103,
	"./App.js": 9103,
	"./Comment": 1008,
	"./Comment.js": 1008,
	"./EditComment": 7840,
	"./EditComment.js": 7840,
	"./EditReply": 4977,
	"./EditReply.js": 4977,
	"./FirebaseConfig": 9728,
	"./FirebaseConfig.js": 9728,
	"./PermittedVoting": 5557,
	"./PermittedVoting.js": 5557,
	"./Popup": 9306,
	"./Popup.js": 9306,
	"./Reply": 9057,
	"./Reply.js": 9057,
	"./SendAComment": 5689,
	"./SendAComment.js": 5689,
	"./SendAReply": 6733,
	"./SendAReply.js": 6733,
	"./images/avatars/image-amyrobson.png": 1695,
	"./images/avatars/image-cordeva.png": 3002,
	"./images/avatars/image-maxblagun.png": 4353,
	"./images/avatars/image-ramsesmiron.png": 3754,
	"./images/icon-delete.svg": 1086,
	"./images/icon-edit.svg": 4702,
	"./images/icon-minus.svg": 207,
	"./images/icon-plus.svg": 6371,
	"./images/icon-reply.svg": 9240,
	"./index": 8305,
	"./index.css": 1174,
	"./index.js": 8305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;